import 'angular';

import { HsyItemsService }   from './hsy.items.service';
import { HsyOrderService }   from './hsy.order.service';
import { HsyStates }         from './hsy.states.ajs';
import { HsySettingsCtrl }   from './hsy.settings';

angular.module('workshop.hsy', [])
  .config(HsyStates)
  .controller('HsySettingsCtrl', HsySettingsCtrl)
  .factory('HsyItems', HsyItemsService)
  .factory('HsyOrder', HsyOrderService);
